<div class="row">
  <div class="col-6">
    <h2><i class="fas fa-address-book"></i> Apsis One Accounts</h2>
  </div>

  <div class="col-6" *ngIf="!(hasOnlyTrialDispenserRole$ | async)">
    <div class="float-right inline-block" data-container="body">
      <button
        [disabled]="!canCreateAccount"
        class="btn btn-success"
        (click)="openCreateAccountModal()"
      >
        <i class="fas fa-plus"></i> Create Account
      </button>
    </div>
  </div>
</div>

<div class="row margin-top-bottom-20px">
  <div class="col-4">
    <app-search-bar
      placeholder="Find account by ID (min 3 characters)"
      [searchQuery]="query"
      (handleSearch)="setSearchQuery($event)"
    ></app-search-bar>
  </div>

  <div class="col-8">
    <app-account-category-filter
      [accountCategories]="accountCategories$ | async"
      [filter]="getPathFilters()"
      (filterByCategory)="filterByCategory($event)"
    ></app-account-category-filter>
  </div>
</div>

<div class="row margin-top-bottom-20px">
  <div class="col-12">
    <app-from-domains-filter
      [state]="fromDomainsFilterState"
      (filterChange)="onFromDomainsFilterChange($event)"
    ></app-from-domains-filter>
  </div>
</div>

<app-accounts-table
  [accounts]="accounts$ | async"
  [isLoadingAccounts]="isLoadingAccounts$ | async"
  [userPermissions]="userPermissions"
  [sortOnAscending$]="sortOnAscending$"
  [loadAllAccounts]="loadAllAccounts"
  (sortAccounts)="sortAccounts()"
  (loadAllHit)="loadAllHit()"
  [licensePackages]="licensePackages$ | async"
  [accountCategories]="accountCategories$ | async"
>
</app-accounts-table>
